import React from 'react';

import { PropertyPanelsProps } from './PropertyPanels';

const RoomPanel: React.FC<PropertyPanelsProps> = ({ property }) => {
  return (
    <div className="room-panel">
      <img src={"/assets/figma/" + property + "-main-room.png"} alt="Main room" className="room-panel__image" />
    </div>
  );
};

export default RoomPanel;